import { mercuryApi } from '$api'
import { singletonQueryClient } from '$utils'
import { PackageDetail } from 'src/components/routes/time/_common/interfaces'

enum QueryKeys {
  PayAdjustmentPackages = 'pay-adjustment-packages',
  PayAdjustmentPackage = 'pay-adjustment-package',
}

// NOTE: the generated coreApi client cannot be used for these endpoints.
// The API serialises package ids as plain strings, but the generated
// PackageModel.fromJS parses them with PackageRef.fromJS which only accepts
// objects, so every id is lost. getPackageById is also broken — it never
// substitutes its {packageRef} path placeholder. Falling back to mercuryApi
// until the SDK is regenerated with the correct contract.

/**
 * Get Pay Adjustment Packages list
 * @param includeActivatedPackagesOnly - when true only returns packages activated for the venue
 * @returns Promise<PackageDetail[]>
 */
export const getAll = async (
  includeActivatedPackagesOnly: boolean = true
): Promise<PackageDetail[]> => {
  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.PayAdjustmentPackages, includeActivatedPackagesOnly],
    queryFn: async () => {
      return await mercuryApi.get<PackageDetail[]>(
        `/pay-rules/packages?includeActivatedPackagesOnly=${includeActivatedPackagesOnly}`
      )
    },
  })
}

/**
 * Get Pay Adjustment Package by Id
 * @param packageId - pay adjustment package id to get
 * @returns Promise<PackageDetail>
 */
export const getById = async (packageId: string): Promise<PackageDetail> => {
  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.PayAdjustmentPackage, packageId],
    queryFn: async () => {
      return await mercuryApi.get<PackageDetail>(
        `/pay-rules/packages/${packageId}`
      )
    },
  })
}
